import { UserRole } from 'shared/types/userRole';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { PermissionConfig } from '../types';

const CREATE_PROJECT_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: false,
  [UserRole.manager]: false,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

const EDIT_PROJECT_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: false,
  [UserRole.manager]: false,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

export const ProjectPermissionManager =
  PermissionManagerFactory.create({
    permissionConfigForCreate: CREATE_PROJECT_PERMISSIONS,
    permissionConfigForEdit: EDIT_PROJECT_PERMISSIONS,
    permissionConfigForDelete: null,
  });
